export default "__VITE_ASSET__B$jLW52r__"